import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { createColumnHelper } from '@tanstack/react-table'

import { Phone } from '@/components/icons'
import { PageCard, PageLayout } from '@/components/ui/page'
import {
	CellText,
	CellTextDate,
	DataTable,
	useDataTable,
} from '@/components/ui/table/data-table'

import { useAuth } from '@/libs/hooks/use-auth'

import { posDeviceList } from '@/features/pos/api'
import type { IPos } from '@/features/pos/type'

export const Route = createFileRoute('/_app/outlet/pos/')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/outlet', 'Outlet'],
					['/pos', 'Point of Sale'],
				]}
			/>
			<DeviceSection />
		</PageLayout>
	)
}

function DeviceSection() {
	return (
		<PageCard.Root>
			<PageCard.Header
				title="Daftar Perangkat"
				actions={
					<PageCard.HeaderAction asChild>
						<Link from={Route.fullPath} to="/outlet/pos/create">
							<Phone />
							Tambah Perangkat
						</Link>
					</PageCard.HeaderAction>
				}
			/>
			<DeviceSectionTable />
		</PageCard.Root>
	)
}

const deviceCh = createColumnHelper<IPos>()
function deviceColumns() {
	return [
		deviceCh.accessor('name', {
			header: () => 'Name',
			cell: ({ row }) => <CellText text={row.original.name} />,
		}),
		deviceCh.accessor('role', {
			header: () => 'Role',
			cell: ({ row }) => <CellText text={row.original.role} />,
		}),
		deviceCh.accessor('pair.status', {
			header: () => 'Pair',
			cell: ({ row }) => {
				const { pair } = row.original
				const { key, status } = pair || {}
				return (
					<CellText
						text={
							status === 'claimed'
								? `Aktif`
								: status === 'revoked'
									? `Inaktif`
									: `Belum dipasangkan: ${key}`
						}
					/>
				)
			},
		}),
		deviceCh.accessor('createdAt', {
			header: () => 'Created At',
			cell: ({ row }) => <CellTextDate date={row.original.createdAt} />,
		}),
	]
}

function DeviceSectionTable() {
	const { outletId } = useAuth((s) => s.outlet)
	const navigate = Route.useNavigate()
	const { data, isLoading } = useQuery(posDeviceList.qry({ oId: outletId }))
	const columns = useMemo(deviceColumns, [])
	const { table } = useDataTable({
		columns,
		data: data?.devices ?? [],
	})

	return (
		<DataTable
			table={table}
			columns={columns}
			isLoading={isLoading}
			onRowClick={(r) => {
				navigate({
					to: '/outlet/pos/$posid',
					params: { posid: r.original.id },
				})
			}}
		/>
	)
}
